<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Versjon
          </th>
          <th class="text-left">
            Periode
          </th>
          <th class="text-left">
            Fra
          </th>
          <th class="text-left">
            Til
          </th>
          <th class="text-left">
            Liten vannføring
          </th>
          <th class="text-left">
            Normalområde
          </th>
          <th class="text-left">
            Stor vannføring
          </th>

        </tr>
      </thead>
      <tbody>
        <tr class="no-table-hover"
          v-for="(item, index) in vannforingKurveData"
          :key="index"
        >
          <td v-if="index === 0 || item.attributes.Versjon !== vannforingKurveData[index - 1].attributes.Versjon" :rowspan="versions[index].rowSpan">{{item.attributes.Versjon}}</td>
          <td>{{item.attributes.periode}}</td>
          <td>{{item.attributes.GyldigFra}}</td>
          <td>{{item.attributes.GyldigTil}}</td>
          <td>{{item.attributes.lavvann}}</td>
          <td>{{item.attributes.normal}}</td>
          <td>{{item.attributes.flom}}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>

</template>

<script>
import MapService from '../../services/MapService'

export default {
  name: "TableRowVannforingsKurve",
  data: () => {
    return {
      vannforingKurveData: [],
      versions: []
    }
  },
  props: {
    timeseriesId: String
  },
  methods: {
    getVannforingsKurveData: function (timeSeriesId) {
      MapService.getTimeseriesVannforingsKurve(timeSeriesId).then(result => {
        result.features.forEach(feature => {
          const found = this.versions.find(element => element.version === feature.attributes.Versjon);
          if (typeof found === 'undefined') {
            this.versions.push({ version: feature.attributes.Versjon, rowSpan: 1 });
          } else {
            found.rowSpan = found.rowSpan + 1;
          }

          feature.attributes.GyldigFra = feature.attributes.GyldigFra
          ? new Date(feature.attributes.GyldigFra).toLocaleDateString("nb-NO")
          : "-";

          feature.attributes.GyldigTil = feature.attributes.GyldigTil
          ? new Date(feature.attributes.GyldigTil).toLocaleDateString("nb-NO")
          : "-";

          this.vannforingKurveData.push(feature);
        });
                
      })
    }
  },
  mounted: function () {
    this.getVannforingsKurveData(this.timeseriesId);
  }
}
</script>

<style>
</style>